import type { ApolloError } from '@apollo/client';

import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';
import { log } from 'src/modules/error-logger';

import { type ProfileAction, ProfileActions } from './reducer';

export const fetchMyProfile = (): ProfileAction => ({
  type: ProfileActions.PROFILE_LOADING,
});

export const profileLoaded = (): ProfileAction => ({
  type: ProfileActions.PROFILE_LOADED,
});

export const myProfileRendered = (): ProfileAction => ({
  type: ProfileActions.PROFILE_RENDERED,
});

export const setProfileSuggestionsExperiment = (
  value: boolean,
): ProfileAction => ({
  type: ProfileActions.SET_PROFILE_SUGGESTIONS_EXPERIMENT,
  payload: value,
});

export const fetchProfileFailure = (error: ApolloError): ProfileAction => {
  const isAuthError = isGraphQLAuthError(error);
  if (isAuthError) {
    return {
      type: ProfileActions.PROFILE_NOT_AUTHENTICATED,
      payload: error,
    };
  }
  log(error, { name: 'Fetch profile' });
  return {
    type: ProfileActions.PROFILE_FAILURE,
    payload: error,
    meta: {
      metrics: {
        error: true,
      },
    },
  };
};
